// extracted by mini-css-extract-plugin
export default {"root":"MemoryChat_root-gfD","loaderWrapper":"MemoryChat_loaderWrapper-F1j","errorState":"MemoryChat_errorState-Kng","errorMessage":"MemoryChat_errorMessage-z1H"};